export interface UploadDynamicInventoryPolicy {
  [key: string]: any;
  // Common required field
  "Material": string;
  
  // Common fields for Spanish and Portuguese
  "Planta"?: string;
  
  // Portuguese fields
  "Data Início"?: string;
  "Data Término"?: string;
  "Estoque Mínimo"?: string | null;
  "Estoque Máximo"?: string | null;
  "Ponto Reabastecimento"?: string | null;
  
  // English fields
  "Unit"?: string;
  "Start Date"?: string;
  "End Date"?: string;
  "Minimum Stock"?: string | null;
  "Maximum Stock"?: string | null;
  "Supply Point"?: string | null;
  
  // Spanish fields
  "Fecha de Inicio"?: string;
  "Fecha de Término"?: string;
  "Stock Mínimo"?: string | null;
  "Stock Máximo"?: string | null;
  "Punto de Reabastecimiento"?: string | null;
}

export const UploadDynamicInventoryPolicyPtBrCSVEmpty = {
  "Material": "",
  "Planta": "",
  "Data Início": "",
  "Data Término": "",
  "Estoque Mínimo": "",
  "Estoque Máximo": "",
  "Ponto Reabastecimento": "",
};

export const UploadDynamicInventoryPolicyEsCSVEmpty = {
  "Material": "",
  "Planta": "",
  "Fecha de Inicio": "",
  "Fecha de Término": "",
  "Stock Mínimo": "",
  "Stock Máximo": "",
  "Punto de Reabastecimiento": "",
};

export const UploadDynamicInventoryPolicyEnCSVEmpty = {
  "Material": "",
  "Unit": "",
  "Start Date": "",
  "End Date": "",
  "Minimum Stock": "",
  "Maximum Stock": "",
  "Supply Point": "",
};

export const UploadDynamicInventoryPolicyRequiredFieldsPtBr = [
  'Material',
  'Planta',
  'Data Início',
  'Data Término'
];

export const UploadDynamicInventoryPolicyRequiredFieldsEs = [
  'Material',
  'Planta',
  'Fecha de Inicio',
  'Fecha de Término'
];

export const UploadDynamicInventoryPolicyRequiredFieldsEn = [
  'Material',
  'Unit',
  'Start Date',
  'End Date'
];
